import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Box, Typography } from "@mui/material";
import { FC } from "react";

interface IColorDotText {
    label: string,
    color: any
}
const ColorDotText: FC<IColorDotText> = ({ label, color }) => {

    return (
        <Box sx={{ display: "flex", alignItems: 'center' }}>
            <FiberManualRecordIcon sx={{ mr: 0.5 }} fontSize="inherit" color={color} />
            <Typography variant='h6' >{label} </Typography>
        </Box>
    )
}

export default ColorDotText